import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { createSettings, editSettings } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import {
  getFirstFormError, getResponseError, setFormError,
} from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import SettingsDTO from '../../../dto/SettingsDTO';

export default function SettingsForm(props) {
  const {
    close = () => {},
    loadData = () => {},
    current = {},
    isEdit = false,
  } = props;
  const dispatch = useDispatch();

  const {
    control,
    getValues,
    formState: { errors },
    setError,
    setFocus,
  } = useForm({
    mode: 'onChange',
    defaultValues: isEdit ? current : {},
  });

  const handleSave = () => {
    const error = getFirstFormError(errors);
    if (error) {
      errorNotification('Сохранение настройки', 'Ошибка заполнения формы');
      const { ref } = error;
      if (ref && ref.name) {
        setFocus(ref.name);
      }
      return null;
    }
    const values = getValues();
    const action = isEdit ? editSettings : createSettings;
    dispatch(action({ payload: values.payload, id: current.id }))
      .then(() => {
        loadData();
        close();
        successNotification('Сохранение настройки', 'Форма сохранена');
      })
      .catch(response => {
        setFormError(response, setError);
        errorNotification('Сохранение настройки', getResponseError({ error: response && response.message ? response.message : '' }));
      });
  };

  const DTO = new SettingsDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header={isEdit ? 'Редактирование настройки' : 'Создание настройки'} title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
            disabled
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.name_label}
            variant="material"
            disabled
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.payload}
            variant="material"
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-show" type="submit" onClick={handleSave}>Сохранить</Button>
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
